import React from "react";
import {
  Checkbox,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  VStack,
  Button,
} from "@chakra-ui/react";
import { ITEM_SOURCE, sourceLabels } from "./templateSectionUtils";

const SectionSettingsDrawer = ({
  isOpen,
  onClose,
  section,
  onChange,
}) => {
  if (!section) return null;

  const patch = (next) => onChange({ ...section, ...next });

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="full">
      <DrawerOverlay />
      <DrawerContent maxW={{ base: "100vw", md: "md" }}>
        <DrawerCloseButton />
        <DrawerHeader>Section settings</DrawerHeader>
        <DrawerBody>
          <VStack align="stretch" spacing={4}>
            <FormControl>
              <FormLabel>Section title</FormLabel>
              <Input size="sm" value={section.title || ""} onChange={(event) => patch({ title: event.target.value })} />
            </FormControl>
            <FormControl>
              <FormLabel>Code</FormLabel>
              <Input size="sm" value={section.code || ""} onChange={(event) => patch({ code: event.target.value })} />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Textarea size="sm" value={section.description || ""} onChange={(event) => patch({ description: event.target.value })} />
            </FormControl>
            <FormControl>
              <FormLabel>Section type</FormLabel>
              <Select size="sm" value={section.type || "CUSTOM"} onChange={(event) => patch({ type: event.target.value, sectionType: event.target.value })}>
                <option value="GOALS">Goals</option>
                <option value="BEHAVIOUR">Behaviour</option>
                <option value="DISCIPLINE">Discipline</option>
                <option value="GROWTH">Growth</option>
                <option value="COMPETENCY">Competency</option>
                <option value="CUSTOM">Custom</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Weightage</FormLabel>
              <Input size="sm" type="number" value={section.weightage || 0} onChange={(event) => patch({ weightage: Number(event.target.value) || 0 })} />
            </FormControl>
            <FormControl>
              <FormLabel>Calculation method</FormLabel>
              <Select size="sm" value={section.calculationMethod || "WEIGHTED_ITEMS"} onChange={(event) => patch({ calculationMethod: event.target.value })}>
                <option value="WEIGHTED_ITEMS">Weighted items</option>
                <option value="AVERAGE_RATING">Average rating</option>
                <option value="SUM_WEIGHTED_SCORES">Sum weighted scores</option>
                <option value="DIRECT_SECTION_SCORE">Direct section score</option>
                <option value="GOAL_PROGRESS_WEIGHTED">Goal progress weighted</option>
                <option value="COMPETENCY_WEIGHTED">Competency weighted</option>
                <option value="360_WEIGHTED">360 weighted</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Item source</FormLabel>
              <Select size="sm" value={section.uiItemSource || ITEM_SOURCE.STATIC_TEMPLATE_ITEMS} onChange={(event) => patch({ uiItemSource: event.target.value })}>
                {Object.values(ITEM_SOURCE).map((source) => (
                  <option key={source} value={source}>{sourceLabels[source]}</option>
                ))}
              </Select>
            </FormControl>
            <Checkbox isChecked={Boolean(section.isRequired || section.mandatory)} onChange={(event) => patch({ isRequired: event.target.checked, mandatory: event.target.checked })}>
              Required section
            </Checkbox>
            <Checkbox isChecked={section.allowEmployeeRating !== false} onChange={(event) => patch({ allowEmployeeRating: event.target.checked })}>
              Allow employee rating
            </Checkbox>
            <Checkbox isChecked={section.allowManagerRating !== false} onChange={(event) => patch({ allowManagerRating: event.target.checked })}>
              Allow manager rating
            </Checkbox>
            <Checkbox isChecked={Boolean(section.commentRequired)} onChange={(event) => patch({ commentRequired: event.target.checked })}>
              Comments required
            </Checkbox>
            <Checkbox isChecked={Boolean(section.evidenceRequired)} onChange={(event) => patch({ evidenceRequired: event.target.checked })}>
              Evidence required
            </Checkbox>
          </VStack>
        </DrawerBody>
        <DrawerFooter>
          <Button size="sm" onClick={onClose}>Done</Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default SectionSettingsDrawer;
